export default __webpack_public_path__ + "static/media/04_photo.586c3c3e.jpg";